// removed by extract-text-webpack-plugin
module.exports = {"DrawerToggle":"DrawerToggle__DrawerToggle__CknPt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Sidedrawer/DrawerToggle/DrawerToggle.css
// module id = 93
// module chunks = 0